import useVelocityClient from '../useVelocityClient';
import { useMemo } from 'react';
import { ZERO, BigNum, QUOTE_PRECISION_EXP } from '@velocity-exchange/sdk';
import { useCurrentAccountPositions } from '../query/accountTradingData/usePositions';
import useUserAccountIsReady from '../useUserAccountIsReady';

export const useIsolatedPositionMargin = (marketIndex: number) => {
	const velocityClient = useVelocityClient();
	const userAccountIsReady = useUserAccountIsReady();
	const perpPositions = useCurrentAccountPositions();
	const perpPositionUnsettledPnl = useMemo(
		() =>
			perpPositions?.find((o) => o.marketIndex === marketIndex)?.unsettledPnl,
		[perpPositions, marketIndex]
	);

	const isolatedDeposit = useMemo(() => {
		if (!userAccountIsReady) return ZERO;
		try {
			// hasUser() can throw when the client is subscribed but the wallet
			// has disconnected (authority cleared), so keep it inside the guard.
			if (!velocityClient?.hasUser()) return ZERO;
			const amount =
				velocityClient.getIsolatedPerpPositionTokenAmount(marketIndex);
			return amount ?? ZERO;
		} catch (e: unknown) {
			console.error('Error getting isolated position margin', e);
			return ZERO;
		}
	}, [
		velocityClient,
		userAccountIsReady,
		marketIndex,
		perpPositions,
		perpPositionUnsettledPnl,
	]);
	const isolatedMargin = isolatedDeposit.add(perpPositionUnsettledPnl ?? ZERO);

	const value = BigNum.from(isolatedMargin, QUOTE_PRECISION_EXP);

	return value;
};
